import { createFileRoute } from '@tanstack/react-router'
import { Home } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'
import { SignalsExploreTab } from '@/features/events/components/SignalsExploreTab'
import { SignalsLiveTab } from '@/features/events/components/SignalsLiveTab'
import {
  SubtleTabs,
  SubtleTabsContent,
  SubtleTabsList,
  SubtleTabsTrigger,
} from '@/shared/components/common/tabs/SubtleTabs'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/shared/hooks/useBreadcrumbs'

export const Route = createFileRoute('/_auth/developers/signals')({
  component: () => <SignalsPage />,
})

function SignalsPage() {
  const [activeTab, setActiveTab] = useState('explore')
  const { setBreadcrumbs } = useBreadcrumbs()

  const breadcrumbsContent = useMemo(
    () => (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink to='/dashboard' className='flex items-center gap-1'>
              <Home className='w-4 h-4' />
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Signals</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    ),
    []
  )

  useEffect(() => {
    setBreadcrumbs(breadcrumbsContent)
  }, [setBreadcrumbs, breadcrumbsContent])

  return (
    <div className='container mx-auto py-6'>
      <div className='space-y-6'>
        {/* Page Header */}
        <div className='space-y-2'>
          <h1 className='text-2xl font-bold'>Signals</h1>
          <p className='text-muted-foreground'>
            Explore and debug signals sent
          </p>
        </div>

        {/* Tabs */}
        <SubtleTabs value={activeTab} onValueChange={setActiveTab}>
          <SubtleTabsList>
            <SubtleTabsTrigger value='explore'>Explore</SubtleTabsTrigger>
            <SubtleTabsTrigger value='live'>Live</SubtleTabsTrigger>
          </SubtleTabsList>

          <SubtleTabsContent value='explore'>
            <SignalsExploreTab />
          </SubtleTabsContent>

          <SubtleTabsContent value='live'>
            <SignalsLiveTab />
          </SubtleTabsContent>
        </SubtleTabs>
      </div>
    </div>
  )
}
